import Service, { inject as service } from '@ember/service';

class SupportCommands extends Service {
  @service api;

  /**
   * Fetch help center articles
   * 
   * @param {Object} options https://developer.zendesk.com/api-reference/help_center/help-center-api/articles/
   * @returns 
   */
  loadHelpCenterArticles(options = {}) {
    return this.api.request('support-articles', options);
  }
}

export default SupportCommands;
